
import { Component, Input } from '@angular/core';

@Component({
    standalone: true,
    selector: 'sh-facet-placeholder',
    templateUrl: './facet-placeholder.component.html',
    styleUrls: ['./facet-placeholder.component.scss'],
    imports: []
})
export class ShFacetPlaceHolderComponent {
    @Input() showLabel: boolean = true;
}
